import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=07a44fa2&scoped=true"
import script from "./Layouts.vue?vue&type=script&lang=js"
export * from "./Layouts.vue?vue&type=script&lang=js"
import style0 from "./Layouts.vue?vue&type=style&index=0&id=07a44fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a44fa2",
  null
  
)

export default component.exports